import { parse, stringify } from 'uuid';
export class BaseNode {
    id;
    key;
    metadata;
    constructor(id, key, metadata) {
        this.id = stringify(parse(id));
        this.key = key;
        this.metadata = metadata || new Map();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZU5vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL3JlY29yZC9CYXNlTm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsS0FBSyxFQUFFLFNBQVMsRUFBRSxNQUFNLE1BQU0sQ0FBQTtBQUl2QyxNQUFNLE9BQWdCLFFBQVE7SUFDbkIsRUFBRSxDQUFRO0lBQ25CLEdBQUcsQ0FBUztJQUNaLFFBQVEsQ0FBVTtJQUVsQixZQUFZLEVBQVUsRUFBRSxHQUFZLEVBQUUsUUFBbUI7UUFDdkQsSUFBSSxDQUFDLEVBQUUsR0FBRyxTQUFTLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7UUFDOUIsSUFBSSxDQUFDLEdBQUcsR0FBRyxHQUFHLENBQUE7UUFDZCxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsSUFBSSxJQUFJLEdBQUcsRUFBRSxDQUFBO0lBQ3ZDLENBQUM7Q0FDRiJ9